// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2-1yM","title":"InfoRow_title__1eGq_"};